var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "8px",
    viewBox: "0 0 15 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1 Copy 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "arrow",
    id: "All-Categories",
    transform: "translate(-1630.000000, -33.000000)",
    fill: "#020F14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1637.12564,38.4459135 C1638.21487,37.4627811 1637.82437,37.3863957 1638.88116,36.3911454 C1639.93879,35.396422 1640.99476,34.4011717 1641.94845,33.3669334 C1642.27439,33.013933 1642.99029,32.8948612 1643.54737,33.1013928 C1644.10362,33.3079243 1644.29153,33.7615561 1643.9656,34.1140296 C1643.96227,34.1182446 1643.95479,34.1250938 1643.95146,34.1293088 C1642.95869,35.1487949 1642.06735,36.2067422 1641.17851,37.2652164 C1640.28801,38.3236906 1639.38587,39.3779499 1638.52779,40.4485421 C1638.12952,40.94485 1637.1725,41.1424249 1636.38925,40.8905828 C1636.09075,40.7946932 1635.86044,40.6466438 1635.71244,40.4733048 L1635.69082,40.4485421 L1630.26798,34.1293088 C1629.9595,33.769986 1630.16903,33.3200423 1630.73609,33.1245749 C1631.27239,32.9396449 1631.9384,33.0508136 1632.27015,33.3669334 L1637.12564,38.4459135 Z",
    id: "Fill-1-Copy-19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIc);
export default __webpack_public_path__ + "static/media/arrow-down-ic.b631ff7fdc949ef9406ef98415f88409.svg";
export { ForwardRef as ReactComponent };